import React, { useState, useEffect, useContext } from 'react'
import { Flex, P, Box } from 'ui/acro'
import { SeriesBox, SeeMoreButton } from '../MyPracticeStyles'
import { LoadMore } from './loadMoreItems'
import SortableList from 'components_v1/sortableList/SortableList'
import { ClassCard } from 'components_v1/SchemaSectionRenderer/common/components'
import MyPracticeLeftFilter from '../../MyPracticeLeftFilter'
// import ClassFinderNewFilteredList from '../../../../components_v1/pageLevelComponents/classFinder/ClassFinderNewFilteredList'
import MyPracticeFilteredList from '../../MyPracticeFilteredList'
import { connect } from 'react-redux'

import styled from 'styled-components'
import MyPracticeNotData from '../../MyPracticeNotData'
import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'
import { clearAllFilters } from '../../../../../javascript/redux/actions/planEntries'
import { getPlanEntryGridState } from '../../../../../javascript/redux/selectors/planEntries'
import usePlaylistDrawer from 'hooks/usePlaylistDrawer'
import { useUserContext } from 'context'
import { MyPracticeDetailsContext } from 'components_v2/page_context'

const Container = styled('div')`
  padding: 0 40px;
  .SelectedFiltersDisplay {
    margin: 0;
  }
  .ContentWrapper {
    @media (max-width: 1024px) {
      flex-direction: column;
    }
  }
  .ClassesComponentDetailsRow {
    .SortableList {
      @media (max-width: 1024px) {
        display: none;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 0;
    .ClassCardContainer {
      justify-content: space-between;
    }
    .CardContainer-Grid {
      a {
        min-width: 150px !important;
      }
    }
  }
`

const ClassesComponent = ({
  userClasses,
  fetchDataClasses,
  setPerPage,
  setPage,
  perPage,
  page,
  totalClasses,
  favoriteCallback,
  setUserClasses,
  ...props
}) => {
  const [isCompleted, setIsCompleted] = useState(false)
  const days = null

  const { classesContext } = useContext(MyPracticeDetailsContext)
  const [selectedClassesOptions, setSelectedClassesOptions] = classesContext

  const [cards, setCards] = useState([])
  const { user } = useUserContext() || {}

  useEffect(() => {
    setCards(userClasses)
  }, [userClasses])

  const updatePlaylistList = (updatedPlaylistIds) => {
    const updatedCards = cards.map((card) =>
      card.id === selectedCardData?.id
        ? { ...card, playlistIds: updatedPlaylistIds }
        : card
    )
    setUserClasses(updatedCards)
  }

  const { handlePlaylistIconClick, AddToPlaylistDrawer, selectedCardData } =
    usePlaylistDrawer(updatePlaylistList)

  const sortOptions = [
    'date',
    'oldest',
    'title',
    'plan',
    'durationShortToLong',
    'durationLongToShort'
  ]

  const loadMore = () => {
    LoadMore(
      setPage,
      setPerPage,
      fetchDataClasses,
      'classes',
      page,
      perPage,
      days
    )
  }

  useEffect(() => {
    const hasNoCards = !Array.isArray(cards) || cards?.length === 0
    const hasAllCards = Array.isArray(cards) && cards?.length === totalClasses

    setIsCompleted(hasNoCards || hasAllCards)
  }, [cards])

  useEffect(() => {
    if (props.currentTab === 'classes' && sortOptions.includes(props.order)) {
      onSortDropDownChange(props.order)
    }
  }, [props.order])

  const onSortDropDownChange = (sortOption) => {
    const { selectedColumn, sorting } = selectedClassesOptions
    let options = {}

    if (sortOption === 'oldest') {
      options = {
        sorting: 'asc',
        selectedColumn: 'date'
      }
    } else if (sortOption === 'date') {
      options = {
        sorting: 'desc',
        selectedColumn: sortOption
      }
    } else if (sortOption === 'durationShortToLong') {
      options = {
        sorting: 'asc',
        selectedColumn: 'duration'
      }
    } else if (sortOption === 'durationLongToShort') {
      options = {
        sorting: 'desc',
        selectedColumn: 'duration'
      }
    } else {
      options = {
        sorting: 'asc',
        selectedColumn: sortOption
      }
    }
    if (
      selectedColumn !== options.selectedColumn ||
      sorting !== options.sorting
    ) {
      setSelectedClassesOptions(options)
    }
  }

  const getSortOrder = () => {
    const { selectedColumn, sorting } = selectedClassesOptions
    let order = selectedColumn
    if (selectedColumn === 'date' && sorting === 'asc') {
      order = 'oldest'
    } else if (selectedColumn === 'duration' && sorting === 'asc') {
      order = 'durationShortToLong'
    } else if (selectedColumn === 'duration' && sorting === 'desc') {
      order = 'durationLongToShort'
    }
    return order
  }

  return (
    <Container>
      {window.innerWidth > 1024 ? (
        <MyPracticeFilteredList
          includeFilters={props.includeFilters}
          dropdownOptions={props.dropdownOptions}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          withSubcategories={props.withSubcategories}
        />
      ) : null}
      <Flex gap='2%' className='ContentWrapper'>
        <MyPracticeLeftFilter
          withSubcategories={props.withSubcategories}
          // autopaginate={props.autopaginate}
          includeFilters={props.includeFilters}
          // planEntries={props.planEntries}
          preloadedFilters={props.preloadedFilters}
          baseUrl={props.baseUrl}
          dropdownOptions={props.dropdownOptions}
          parent_tab={'classes'}
          currentTab={props.currentTab}
          fetchMyPracticeInfo={fetchDataClasses}
          currentUser={user}
          totalCount={totalClasses}
        ></MyPracticeLeftFilter>
        <Flex
          alignItems='center'
          flexDirection='column'
          justifyContent='flex-start'
          mt={['none', 'none', '1rem', '1rem']}
          width={['100%', '100%', '100%', '80%']}
        >
          <Flex
            flexDirection='row'
            justifyContent={[
              'space-between',
              'space-between',
              'space-between',
              'space-between'
            ]}
            pt={[0, 0]}
            pl={['5%', '20px', '10px', '5px']}
            pr={['5%', '20px', '10px', '5px']}
            width='100%'
            className='ClassesComponentDetailsRow'
          >
            <P alignSelf='flex-end' fontSize='16px'>
              {totalClasses} Classes
            </P>
            <SortableList
              sortableFields={sortOptions}
              order={getSortOrder()}
              onSort={onSortDropDownChange}
              sortLocation={'Classes'.toLowerCase()}
            />
          </Flex>

          {props.loading && <AloMovesAnimation />}
          {!props.loading && cards.length <= 0 && (
            <MyPracticeNotData
              option={'classes'}
              text={'NO VIDEOS HERE YET...'}
            />
          )}
          {!props.loading && cards.length > 0 && (
            <SeriesBox
              id='Users-Series'
              inTrigger={cards && true}
              appear={true}
              className='ClassCardContainer'
            >
              {cards.map((classItem) => {
                return (
                  <Box
                    key={classItem.id}
                    width={
                      cards.length === 1
                        ? ['100%', '100%', 'auto', 'auto']
                        : props.layout == 'list'
                        ? ['100%', '33.33%', '33.33%', '33.33%']
                        : ['45%', '33.33%', '33.33%', '33.33%']
                    }
                    p={['1rem 0', '1rem', '2rem', '2rem']}
                    borderBottom={['1px solid #ECECEC', '0']}
                    style={{
                      position: 'relative'
                    }}
                    className={
                      props.layout == 'list'
                        ? 'CardContainer-List'
                        : 'CardContainer-Grid'
                    }
                  >
                    <ClassCard
                      {...classItem}
                      humanDuration={classItem.duration}
                      videoThumbnail={classItem.image}
                      plan={classItem.plan}
                      alignBox={'left'}
                      variantTitle='secondary'
                      variantSubtitle='secondary'
                      planEntryUrl={classItem.classUrl}
                      favoriteCallback={favoriteCallback}
                      isGridView={props.layout === 'tile'}
                      membershipTier={user?.membershipTier}
                      onPlaylistIconClick={() =>
                        handlePlaylistIconClick(classItem)
                      }
                      pb='20px'
                    />
                  </Box>
                )
              })}
            </SeriesBox>
          )}
          {!isCompleted && !props.loading && (
            <SeeMoreButton onClick={loadMore}>See More</SeeMoreButton>
          )}
          {AddToPlaylistDrawer}
        </Flex>
      </Flex>
    </Container>
  )
}

const mapStateToProps = (state) => {
  const planEntryGridState = getPlanEntryGridState(state)
  return {
    order: state.ui.planEntries.order,
    layout: planEntryGridState.layout
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearAllFilters: () => {
      dispatch(clearAllFilters())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClassesComponent)
